import React, { Component } from 'react';
import {
  withRouter,
  Link
} from 'react-router-dom';
import { invokeApig } from '../libs/awsLib';
import {
  FormControl,
  InputGroup,
  ListGroup,
  ListGroupItem,
  Glyphicon,
  Col,
  Panel,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  PageHeader
} from 'react-bootstrap';
import LoaderButton from '../components/LoaderButton';
import ItemWithTooltip from '../components/ItemWithTooltip';
import CustomListGroupItem from '../components/CustomListGroupItem';
import './Customers.css';
import config from '../config.js';

class Customers extends Component {
    constructor(props) {
        super(props);

        this.file = null;
        this.state = {
          isLoading: null,
          isDeleting: false,
          isRunningImport: false,
          isUpdatingTask: false,
          hasCompletedImport: false,
          isRunningReport: false,
          customer: null,
          customerIndex: '',
          s3url:'',
          files: [],
          reports:[],
          importType: 2,
          reportType: "spotcheck",
          tasks: []
        };
    }

    async componentWillMount() {
        // These async calls should be improved to show loading components in UI
        try {
            const results = await this.getCustomer();
            this.setState({
                customer: results,
                customerIndex: results.customerIndex,
                s3url: results.s3SignedURL
            });
            await this.updateCustomerTasks();
            const files = await this.getCustomerFiles();
            this.setState({files: files});
            const reports = await this.getCustomerReports();
            this.setState({reports: reports});
            console.log(this.state.customer.customerSFDCName);
            console.log(this.state.customer);
        }
        catch(e) {
            console.log("Error fetching data:" + e);
          // alert(e);
        }
    }

    async getCustomer() {
      var token = await this.props.getUserToken();
      return invokeApig({ path: `/customers/${this.props.match.params.id}` }, token);
    }

    async getCustomerFiles() {
      var token = await this.props.getUserToken();
      return invokeApig({ path: `/customers/${this.props.match.params.id}/files` }, token);
    }

    async getCustomerTasks() {
      var token = await this.props.getUserToken();
      return invokeApig({ path: `/customers/${this.props.match.params.id}/tasks` }, token);
    }


    async getCustomerReports() {
      var token = await this.props.getUserToken();
      return invokeApig({ path: `/customers/${this.props.match.params.id}/reports` }, token);
    }

    validateForm() {
        var letterNumber = /^[0-9a-zA-Z]+$/;
        if(!(this.state.customerIndex.match(letterNumber)))
        {
          return false;
        }
        return this.state.customerIndex.length > 0;
    }

    handleChange = (event) => {
        this.setState({
          [event.target.id]: event.target.value
        });
    }

    async saveCustomer(customer) {
      var token = await this.props.getUserToken();
      return invokeApig({
        path: `/customers/${this.props.match.params.id}`,
        method: 'PUT',
        body: customer,
      }, token);
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        this.setState({ isLoading: true });
        try {
          await this.saveCustomer({
            ...this.state.customer,
            customerIndex: this.state.customerIndex,
          });
          this.props.history.push('/');
        }
        catch(e) {
          alert(e);
        }
        this.setState({ isLoading: false });
    }

    async deleteCustomer() {
      var token = await this.props.getUserToken();
      return invokeApig({
            path: `/customers/${this.props.match.params.id}`,
            method: 'DELETE',
      }, token);
    }

    handleDelete = async (event) => {
        event.preventDefault();

        const confirmed = window.confirm('Are you sure you want to delete "' + this.state.customerIndex + '" customer?\n\n' +
          'This action cannot be undone and will delete all data permanently!');

        if ( ! confirmed) {
            return;
        }

        this.setState({ isDeleting: true });

        try {
            await this.deleteCustomer();
            this.props.history.push('/');
        }
        catch(e) {
            alert(e);
        }
        this.setState({ isDeleting: false });
    }

    async importCustomer() {
      var token = await this.props.getUserToken();
        return invokeApig({
            path: `/customers/${this.props.match.params.id}/import`,
            method: 'POST',
            body: {importType: this.state.importType,},
        }, token);
    }

    handleImport = async (event) => {
        event.preventDefault();

        this.setState({ isRunningImport: true });

        try {
          await this.importCustomer();
          await this.updateCustomerTasks();
        }
        catch(e) {
            alert(e);
        }
    }

    updateCustomerTasks = async () => {
      try {
        const tasks = await this.getCustomerTasks();
        function custom_sort(a, b) {
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        }
        tasks.sort(custom_sort);
        this.setState({tasks: tasks});
        var foundRunningReport = false,
            foundRunningImport = false,
            foundCompletedImport = false;
        for (var i = 0, l = tasks.length; i < l; i++) {
          var task = tasks[i];
          // Change import button state if import is running
          if ((task.taskType === "create_import") && !((task.taskStatus === 'stopped') || (task.taskStatus === 'complete') || (task.taskStatus === 'failed'))) {
            foundRunningImport = true;
          }
          // Change report button state if import has completed
          if ((task.taskType === "create_import") && (task.taskStatus === 'complete')) {
            foundCompletedImport = true;
          }
          // Change report button state if report is running
          if ((task.taskType === "create_report") && !((task.taskStatus === 'stopped') || (task.taskStatus === 'complete') || (task.taskStatus === 'failed'))) {
            foundRunningReport = true;
          }
        }
        this.setState({isRunningImport: foundRunningImport});
        this.setState({hasCompletedImport: foundCompletedImport});
        this.setState({isRunningReport: foundRunningReport});
      }
      catch(e) {
        alert(e);
      }
    }

  // UI action handler function
  handleUpdateTasks = async (event) => {
    event.preventDefault();
    this.setState({ isUpdatingTask: true });
    try {
      await this.updateCustomerTasks();
    }
    catch(e) {
      alert(e);
    }
    this.setState({ isUpdatingTask: false });
  }

  // Set import type selected in radiobar
    handleImportType = async (value) => {
        this.setState({ importType: value});
    }

    // Set report type selected in radiobar
    handleReportType = async (value) => {
      this.setState({ reportType: value});
    }

    async deleteFile(key) {
      var token = await this.props.getUserToken();
      return invokeApig({
          path: `/customers/${this.props.match.params.id}/files/${key}`,
          method: 'DELETE',
      }, token);
    }

    handleDeleteFile = async (key, event) => {
        event.preventDefault();

        const confirmed = window.confirm('Are you sure you want to delete this file?');

        if ( ! confirmed) {
            return;
        }

        try {
            var uriKey = encodeURIComponent(key);
            await this.deleteFile(uriKey);
            const files = await this.getCustomerFiles();
            this.setState({ files: files });
        }
        catch(e) {
            alert(e);
        }
    }
  
    async runReportCustomer() {
      var token = await this.props.getUserToken();
      return invokeApig({
        path: `/customers/${this.props.match.params.id}/reports`,
        method: 'POST',
        body: {reportType: this.state.reportType},
      }, token);
    }

    handleRunReport = async (event) => {
        event.preventDefault();

        this.setState({ isRunningReport: true });

        try {
          await this.runReportCustomer();
          await this.updateCustomerTasks();
        }
        catch(e) {
          alert(e);
        }
    }

    async getCustomerReport(key) {
      var token = await this.props.getUserToken();
      return invokeApig({ path: `/customers/${this.props.match.params.id}/reports/${key}` }, token);
    }

    handleGetReport = async (key, event) => {
        event.preventDefault();

        try {
            const uriKey = encodeURIComponent(key);
            const result = await this.getCustomerReport(uriKey);
            window.location.href = result.url;
            const reports = await this.getCustomerReports();
            this.setState({ reports: reports });
        }
        catch(e) {
            alert(e);
        }
    }

    async deleteReport(key) {
      var token = await this.props.getUserToken();
      return invokeApig({
          path: `/customers/${this.props.match.params.id}/reports/${key}`,
          method: 'DELETE',
      }, token);
    }

    handleDeleteReport = async (key, event) => {
        event.preventDefault();
        event.stopPropagation();

        const confirmed = window.confirm('Are you sure you want to delete this report?');

        if ( ! confirmed) {
            return;
        }

        try {
            const uriKey = encodeURIComponent(key);
            await this.deleteReport(uriKey);
            const reports = await this.getCustomerReports();
            this.setState({ reports: reports });
        }
        catch(e) {
            alert(e);
        }
    }

    getTaskConfig(status) {
      // pending|scheduled|running|stopped|complete|stuck|failed
      switch (status){
        case "initiated":
          return 'play';
        case "pending":
          return 'pause';
        case "scheduled":
          return 'time';
        case "running":
          return 'play';
        case "stopped":
          return 'stop';
        case "complete":
          return 'ok';
        case "stuck":
          return 'exclamation-sign';
        case "failed":
          return 'exclamation-sign';
        default:
          return 'refresh';
      }
    }

  render() {
    return (
      <div className="Customers">
        <PageHeader>Customer control panel</PageHeader>
        <Col xs={16} md={8} >
          <Panel>
            <Panel.Heading>
              <Panel.Title componentClass="h2">Customer Profile</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <small>
                <b>OAS Name: </b>{this.state.customerIndex}
                <br/>
                <b>SFDC Name: </b>{(this.state.customer)?this.state.customer.customerSFDCName : ""}
                <br/>
                <b>SFDC SE Activity: </b>{(this.state.customer)?this.state.customer.customerSFDCSalesEngineeringActivity : ""}
                <br/>
                <b>SFDC Opportunity Link: </b>{ (this.state.customer) ? this.state.customer.customerSFDCOpportunityURL : ""}
              </small>
            </Panel.Body>
          </Panel>
          <Panel>
            <Panel.Heading>
              <Panel.Title componentClass="h2">Sysdumps Upload URL</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <InputGroup>
                <InputGroup.Addon>
                 <Glyphicon glyph="link" />
                </InputGroup.Addon>
                <ItemWithTooltip placement="bottom" id="tp-1" tooltip="Anonymous file upload URL, can be shared with end users.">
                  <FormControl autoFocus type="text" value={this.state.s3url}/>
                </ItemWithTooltip>
              </InputGroup>
            </Panel.Body>
          </Panel>
          <Panel>
            <Panel.Heading>
              <Panel.Title componentClass="h2">Uploaded Sysdumps</Panel.Title>
            </Panel.Heading>
            <ListGroup>
              {
                [{}].concat(this.state.files).map((custFile, i) => (
                  i !== 0
                  ? ( <CustomListGroupItem
                                key={custFile.ETag}
                                leftImage="/archive-64-b.png"
                                Title={custFile.Key.split('/').pop()}
                                fileSize={custFile.Size}
                                modifiedDate={custFile.LastModified}
                                handleDelete={(evt) => this.handleDeleteFile(custFile.Key, evt)}
                            /> )
                  : ( <ListGroupItem
                          key="new">
                          <Link to={this.state.s3url} target="_blank">
                            <h4><b>{'\uFF0B'}</b> Upload new sysdump</h4>
                          </Link>
                      </ListGroupItem> )
                ))
              }
            </ListGroup>
          </Panel>
          <Panel>
            <Panel.Heading>
              <Panel.Title componentClass="h2">Downloadable Reports</Panel.Title>
            </Panel.Heading>
            <ListGroup>
            {
              [{}].concat(this.state.reports).map((reportFile, i) => (
                (i !== 0) &&
                ( <CustomListGroupItem
                          key={reportFile.ETag}
                          onClick={(evt) => this.handleGetReport(reportFile.Key, evt)}
                          href={"#"}
                          leftImage="/report-3-64-y.png"
                          Title={reportFile.Key.split('/').pop()}
                          fileSize={reportFile.Size}
                          modifiedDate={reportFile.LastModified}
                          handleDelete={(evt) => this.handleDeleteReport(reportFile.Key, evt)}
                      /> )
            ))
          }
          </ListGroup>
          </Panel>
        </Col>
        <Col xs={16} md={4} >
          { this.state.customer &&
            ( <form onSubmit={this.handleSubmit}>
              <Panel>
                <Panel.Heading>
                  <Panel.Title componentClass="h2">Actions</Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                <Panel>
                  <Panel.Body>
                    <ItemWithTooltip
                      placement="bottom"
                      id="tp-2"
                      tooltip="No Messages - discards all messages logs. Speeds up Spotcheck reports.
                      No Info - strips Info messages. Good for all reports (default).
                      All Messages - indexes all events, very slow indexing."
                    >
                      <ToggleButtonGroup
                          justified
                          type="radio"
                          name="importType"
                          value={this.state.importType}
                          onChange={this.handleImportType}
                      >
                          <ToggleButton value={1}>
                              No Logs
                          </ToggleButton>
                          <ToggleButton value={2}>
                              No Info Logs
                          </ToggleButton>
                          <ToggleButton value={3}>
                              All Logs
                          </ToggleButton>
                      </ToggleButtonGroup>
                    </ItemWithTooltip>

                    <LoaderButton
                      block
                      bsStyle="primary"
                      bsSize="large"
                      disabled={ (this.state.files.length <= 0) }
                      isLoading={this.state.isRunningImport}
                      onClick={this.handleImport}
                      text="Import Sysdumps"
                      loadingText="&nbsp;Importing Sysdumps…" />
                    </Panel.Body>
                  </Panel>
                  <Panel>
                    <Panel.Body>
                      <ItemWithTooltip
                        placement="bottom"
                        id="tp-3"
                        tooltip="Select a report type you need. Some reports may appear disabled based on your OAS entitlement level."
                      >
                        <ToggleButtonGroup
                          justified
                          type="radio"
                          name="reportType"
                          value={this.state.reportType}
                          onChange={this.handleReportType}
                        >
                          {/*<ToggleButton value={"all"}>*/}
                            {/*All Reports*/}
                          {/*</ToggleButton>*/}
                          <ToggleButton value={"spotcheck"}>
                            Spot Check
                          </ToggleButton>
                          <ToggleButton value={"oassummary"} disabled={(config.ui.reportsRestricted === 1) ? true : false}>
                            OAS Brief
                          </ToggleButton>
                          <ToggleButton value={"oaslight"} disabled={(config.ui.reportsRestricted === 1) ? true : false}>
                            OAS Light
                          </ToggleButton>
                          <ToggleButton value={"allevents"} disabled={(config.ui.reportsRestricted === 1) ? true : false}>
                            OAS Full
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </ItemWithTooltip>
                      <LoaderButton
                        block
                        bsStyle="primary"
                        bsSize="large"
                        disabled={ !this.state.hasCompletedImport }
                        isLoading={this.state.isRunningReport}
                        onClick={this.handleRunReport}
                        text="Generate Reports"
                        loadingText="&nbsp;Generating Reports…" />
                    </Panel.Body>
                  </Panel>
                  <ItemWithTooltip
                    placement="bottom"
                    id="tp-2"
                    tooltip="Container launch can take from 5-15mins. Containers automatically hibernate after 1hr idle."
                  >
                    <Button
                        block
                        bsStyle="primary"
                        bsSize="large"
                        disabled={false}
                        onClick={(evt) => {evt.preventDefault(); window.open(`${config.externalURL.splunkURL}/${this.props.match.params.id}`, "_blank");}}>
                        <Glyphicon glyph="signal" /> Open Splunk
                    </Button>
                  </ItemWithTooltip>
                </Panel.Body>
              </Panel>
                <Panel>
                  <Panel.Heading>
                    <Panel.Title componentClass="h2">
                      Task List
                      <LoaderButton
                        className="pull-right"
                        bsStyle="default"
                        bsSize="xsmall"
                        disabled={false}
                        isLoading={this.state.isUpdatingTask}
                        text={<Glyphicon glyph="refresh"/>}
                        onClick={(evt) => this.handleUpdateTasks(evt)}>
                      </LoaderButton>
                    </Panel.Title>
                  </Panel.Heading>
                    <ListGroup>
                        {
                            [{}].concat(this.state.tasks).map((task, i) => (
                                (i !== 0) &&
                                ( <ListGroupItem
                                    key={task.taskId}
                                    header="">
                                    <small>
                                        <Glyphicon glyph={this.getTaskConfig(task.taskStatus)}/>
                                        {
                                            "  "
                                            + task.taskType
                                            + " status is "
                                            + task.taskStatus
                                            + ". Created at: "
                                            + (new Date(parseFloat(task.createdAt)).toISOString())
                                        }
                                    </small>
                                </ListGroupItem> )
                            ))
                        }
                    </ListGroup>
                </Panel>
                <Panel>
                  <Panel.Heading>
                    <Panel.Title componentClass="h2">Edit Account</Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <LoaderButton
                        block
                        bsStyle="danger"
                        bsSize="large"
                        isLoading={this.state.isDeleting}
                        onClick={this.handleDelete}
                        text="Delete"
                        loadingText="&nbsp;Deleting…" />
                  </Panel.Body>
                </Panel>
              </form> )}
          </Col>
      </div>
    );
  }
}

export default withRouter(Customers);


// WEBPACK FOOTER //
// ./src/containers/Customers.js